import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";
import { Partnership } from "../../../service/api-response/PartnershipListSuccessResponse";

export const LIST_SUCCESS = "PARTNERSHIP:LIST_SUCCESS";

export interface ListSuccessAction extends Action {
  type: typeof LIST_SUCCESS;
  organization: OrganizationKeyName;
  data: Partnership[];
}

export const listSuccessAction = (
  organization: OrganizationKeyName,
  data: Partnership[]
): ListSuccessAction => ({
  type: LIST_SUCCESS,
  organization,
  data,
});
